export default {
    packages_main_title: 'Packages',
    packages_main_add_packages: 'Add Package',
    packages_main_name: 'Name',
    packages_main_project: 'Platform',
    packages_main_dealer: 'Brand',
    packages_main_created_at: 'Created At',
    packages_main_edit: 'Edit',
    packages_main_account: 'Account',
    packages_main_assigned: 'Assigned',
    packages_main_temaple: '* Template'
};
